import { ToastMessageService } from './layout/toast-message/toast-message.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ViewModelLocator } from '../view-models/view-model-locator';
import { ProvidersForViewModel } from '../view-models/providers-for-view-model';
import { ModalService } from '../view-models/modal/modal.service';
import { AuthService } from '../auth/auth.service';
import { EnvironmentConfiguration } from '@nts/std/environments';
import { OnlineService } from '@nts/std/utility';
import { ResponseCacheService } from '../responses/response-cache.service';
import { WebApiServiceAgent } from '../api-clients/web-api-service-agent';
import { ClassConstructor } from '@nts/std/serialization';
import { CustomFieldComponentInterface } from './controls';
import { BaseAggregateComponent } from './base-aggregate/base-aggregate.component';
import { RoutingService } from '../routing/routing.service';
import { CoreOrchestratorViewModelInterface, RootViewModelInterface, WingViewModelInterface } from '@nts/std/interfaces';
import { ToolBarComponentInterface } from '@nts/std/interfaces';
import { ToolbarComponentRegistry } from '../../../components/helpers/toolbar-component-registry';

@Injectable()
export class ComponentLocator {

    private _registeredViewModelComponenteAssociations = new Map<any, ClassConstructor<any>>();
    private _registeredCustomComponentAssociations = new Map<string, ClassConstructor<CustomFieldComponentInterface>>();

    constructor(
        private modalService: ModalService,
        protected httpClient: HttpClient,
        protected environmentConfiguration: EnvironmentConfiguration,
        protected authService: AuthService,
        protected toastMessageService: ToastMessageService,
        protected onlineService: OnlineService,
        protected responseCacheService: ResponseCacheService,
        protected webApiServiceAgent: WebApiServiceAgent,
        protected routingService: RoutingService,
        protected toolbarRegistry: ToolbarComponentRegistry,
    ) {
        ViewModelLocator.registerZoomOrchestratorViewModelProviders(
            this.getStaticProvidersForZoomOrchestratorViewModel(modalService)
        );
    }

    protected getStaticProvidersForZoomOrchestratorViewModel(modalService: ModalService) {
        return ProvidersForViewModel.staticProvidersForZoomOrchestratorViewModel(
            modalService,
            this.httpClient,
            this.environmentConfiguration,
            this.authService,
            this.toastMessageService,
            this.onlineService,
            this.responseCacheService,
            this.webApiServiceAgent
        );
    }

    getComponentType(viewModelType: any): ClassConstructor<any> | undefined {
        return this._registeredViewModelComponenteAssociations.get(viewModelType);
    }

    getCustomComponentType(customComponentUniqueId: string): ClassConstructor<CustomFieldComponentInterface> | undefined {
        return this._registeredCustomComponentAssociations.get(customComponentUniqueId);
    }

    registerAllForDomainModelType(
        domainModelName: string,
        orchestratorDocumentViewModelType: ClassConstructor<CoreOrchestratorViewModelInterface>,
        rootViewModelType: ClassConstructor<RootViewModelInterface>,
        componentType: ClassConstructor<BaseAggregateComponent<RootViewModelInterface, CoreOrchestratorViewModelInterface>>,
        wingViewModelType?: ClassConstructor<WingViewModelInterface>,
        wingComponentType?: ClassConstructor<any>,
        toolbarComponentType?: ClassConstructor<ToolBarComponentInterface>,
    ) {

        this.registerAllForDomainModelTypeWithProviders(
            domainModelName,
            orchestratorDocumentViewModelType,
            rootViewModelType,
            componentType,
            wingViewModelType,
            wingComponentType,
            toolbarComponentType
        );

    }

    registerViewModelComponentAssociation(viewModelType: any, componentType: ClassConstructor<any>) {
        this._registeredViewModelComponenteAssociations.set(viewModelType, componentType);
    }

    registerCustomComponentAssociation(customComponentUniqueId: string, customComponentType: ClassConstructor<CustomFieldComponentInterface>) {
        this._registeredCustomComponentAssociations.set(customComponentUniqueId, customComponentType);
    }

    registerAllForDomainModelTypeWithProviders(
        domainModelName: string,
        orchestratorViewModelType: ClassConstructor<CoreOrchestratorViewModelInterface>,
        rootViewModelType: ClassConstructor<RootViewModelInterface>,
        componentType: ClassConstructor<any>,
        wingViewModelType?: ClassConstructor<WingViewModelInterface>,
        wingComponentType?: ClassConstructor<any>,
        toolbarComponentType?: ClassConstructor<ToolBarComponentInterface>,
    ) {

        this.registerViewModelComponentAssociation(
            rootViewModelType, componentType);

        ViewModelLocator.registerDomainModelNameOrchestratorViewModel(
            domainModelName.toLowerCase(),
            orchestratorViewModelType,
        );

        if (wingViewModelType) {
            // Wing
            this.registerViewModelComponentAssociation(
                wingViewModelType, wingComponentType);

            ViewModelLocator.registerOrchestratorViewModelWingViewModel(
                orchestratorViewModelType,
                wingViewModelType
            );
        }

        if (toolbarComponentType) {
            this.toolbarRegistry.register(domainModelName.toLowerCase(), toolbarComponentType);
        }
    }
}
